export const TRANSCRIPTION_STATUS = Object.freeze({
  IDLE: 'idle',
  READY: 'ready',
  PREPARING: 'preparing',
  TRANSCRIBING: 'transcribing',
  COMPLETE: 'complete',
  CANCELLED: 'cancelled',
  ERROR: 'error',
});

export const initialSessionState = Object.freeze({
  status: TRANSCRIPTION_STATUS.IDLE,
  chunks: [],
  currentChunk: 0,
  totalChunks: 0,
  error: null,
  errorDetails: null,
});

export function canStartTranscription(status) {
  return status === TRANSCRIPTION_STATUS.READY || status === TRANSCRIPTION_STATUS.CANCELLED;
}

export function sessionReducer(state, action) {
  switch (action.type) {
    case 'file-ready':
      return { ...initialSessionState, status: TRANSCRIPTION_STATUS.READY };
    case 'preparing':
      return { ...state, status: TRANSCRIPTION_STATUS.PREPARING, chunks: [], error: null, errorDetails: null };
    case 'transcribing':
      return { ...state, status: TRANSCRIPTION_STATUS.TRANSCRIBING, currentChunk: action.currentChunk, totalChunks: action.totalChunks };
    case 'chunks':
      return { ...state, chunks: [...state.chunks, ...action.chunks] };
    case 'complete':
      return { ...state, status: TRANSCRIPTION_STATUS.COMPLETE };
    case 'cancelled':
      return { ...state, status: TRANSCRIPTION_STATUS.CANCELLED };
    case 'error':
      return { ...state, status: TRANSCRIPTION_STATUS.ERROR, error: action.error, errorDetails: action.errorDetails || null };
    case 'reset':
      return initialSessionState;
    default:
      return state;
  }
}
